import DarkMeshBackground from "./components/DarkMeshBackground";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import StatsBar from "./components/StatsBar";
import ProblemSolution from "./components/ProblemSolution";
import Features from "./components/Features";
import WorkSteps from "./components/WorkSteps";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import WhyAAIT from "./components/WhyAAIT";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";

export default function HomeV2() {
  return (
    <div className="dark-v2 min-h-screen bg-[#030712] text-slate-100 relative overflow-x-hidden w-full max-w-full">
      <DarkMeshBackground />
      <div className="relative z-10">
        <Header />
        <main className="overflow-x-hidden max-w-full">
          <HeroSection />
          <StatsBar />
          <ProblemSolution />
          <Features />
          <WorkSteps />
          <Services />
          <Portfolio />
          <WhyAAIT />
          <Testimonials />
          <FAQ />
          <CTASection />
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </div>
  );
}
